const lang = {
    'title': '新聞室',
    'request': '如有媒體或採訪需求，請聯絡：<a href="mailto:press.tw@ridegoshare.com" target="_blank" rel="noopener noreferrer">press.tw@ridegoshare.com</a>，我們將儘快回覆。',
};

export default lang;
